import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ManageChildHeadersService } from './../../Common/Services/manage-child-headers.service';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { AppGlobals } from './../../Common/Services/app.global';


@Component({
  selector: 'app-schedule-exam-location',
  templateUrl: './schedule-exam-location.component.html',
  styleUrls: ['./schedule-exam-location.component.css']
})

export class ScheduleExamLocationComponent implements OnInit {
  scheduleExamLocationModel: any = {};
  selectedExamModel: any = {};
  infoWindowOpened = null;


  @ViewChild('locationScroll') locationScroll: PerfectScrollbarComponent;

  constructor(public _utility: Utility, private _appGlobals: AppGlobals, private _router: Router, private _sharedService: SharedService, private _manageChildHeadersService: ManageChildHeadersService) {

  }

  /**
   * Call this function when click on marker on Map
   * Close marker window which was previous opened and Open new One.
   * One time only , one marker will be display.
   */
  openMarkerWindow(infoWindow: any) {
    if (this.infoWindowOpened === infoWindow)
      return;
    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();
    this.infoWindowOpened = infoWindow;
  }

  ngOnInit() {
    if (!this._appGlobals.selectedExamModel) {
      this._router.navigate([(this._utility.leftMenusList_CUser && this._utility.leftMenusList_CUser.landingUrl) ? this._utility.leftMenusList_CUser.landingUrl : '/**']);
      return;
    }
    else {
      this.selectedExamModel = this._appGlobals.selectedExamModel;
      if (this._utility.usesVirtualLocation(this.selectedExamModel)) {
        this._router.navigate(['/ScheduleExamDate']);
      }
      this._utility.setTxnStatus(true);
      this.scheduleExamLocationModel = {
        pageLoad: true,
        searchStr: "",
        examLocations: [],
        mapCenterLat: null,
        mapCenterLng: null,
        cLocLat: null, // current location latitude
        cLocLng: null //// current location longitude
      };
      if (!this._utility.usesVirtualLocation(this.selectedExamModel)) {
        this.getCurrentLocation(true);
      }
    }
  }

  // to highlight selected address in google map
  highlightAddress(location) {
    this.scheduleExamLocationModel.mapCenterLat = location.latitude;
    this.scheduleExamLocationModel.mapCenterLng = location.longitude;
  }

  // To get the current location of user
  getCurrentLocation(pageLoad = false) {

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition(position => {

        this.scheduleExamLocationModel.cLocLat = position.coords.latitude;
        this.scheduleExamLocationModel.cLocLng = position.coords.longitude;
        this.scheduleExamLocationModel.mapCenterLat = this.scheduleExamLocationModel.cLocLat;
        this.scheduleExamLocationModel.mapCenterLng = this.scheduleExamLocationModel.cLocLng;
        this.scheduleExamLocationModel.searchStr = ""; // blank search string when click on near by Icon or search nearly location
        this.setSearchLocations('NEARBY', this.scheduleExamLocationModel.cLocLat, this.scheduleExamLocationModel.cLocLng, pageLoad);
      }, error => {

        setTimeout(() => {

          this.mapExistCountry();
        }, 700);
        // if in any case User block current User then center map on the basis of selected country
      },
        {
          maximumAge: Infinity,
          timeout: 20000
        }
      );
    }
  }

  mapExistCountry() {
    var geocoder = new (<any>window).google.maps.Geocoder();
    var address = this._utility.selectedCountry;
    geocoder.geocode({ 'address': address }, (results, status) => {
      if (status == 'OK') {
        var lat = results[0].geometry.location.lat();
        var lng = results[0].geometry.location.lng();
        this.scheduleExamLocationModel.cLocLat = lat;
        this.scheduleExamLocationModel.cLocLng = lng;
        this.scheduleExamLocationModel.mapCenterLat = lat;
        this.scheduleExamLocationModel.mapCenterLng = lng;

      }
      else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

  // redirect to next page to Select Exam date and time
  proceedToSchedule(exLocation) {
    this._appGlobals.selectedExamLocationModel = exLocation;
    this._router.navigate(['/ScheduleExamDate']);
  }

  // start search new locations if 'enter' key pressed
  handleKeyDown(event: any) {
    if (event.keyCode == 13) {
      this.callSearchLocations();
    }
  }

  // call search locations if new search string entered
  callSearchLocations() {
    let model = this.scheduleExamLocationModel;
    if (model.searchStr && model.searchStr.length >= 3) {
      this.infoWindowOpened = null; // set null because when we search new location : map loads again.
      this.setSearchLocations('SEARCH');
    }
  }

  setScroll() {
    setTimeout(() => {
      this.locationScroll.directiveRef.scrollToTop(0);
      this.locationScroll.directiveRef.update();
    }, 10);
  }

  // start search for new locations
  setSearchLocations(searchType = 'SEARCH', userLatitude = null, userLongitude = null, pageLoad = false) {
    let searchStr = this.scheduleExamLocationModel.searchStr;
    let urlParams = "?searchType=" + searchType;
    urlParams += "&examId=" + this.selectedExamModel.examId;
    urlParams += "&domain=" + this._utility.getCandidateEmail();

    if (searchType == 'SEARCH') {
      urlParams += "&searchText=" + searchStr.toString().trim();
    } else {
      urlParams += "&userLatitude=" + userLatitude;
      urlParams += "&userLongitude=" + userLongitude;
    }

    this._utility.addLoaderCount();
    this._sharedService.getExamAddressList(urlParams)
      .subscribe(
      (response: any) => {
        this._utility.onSuccessCallback(response, null, () => {
          this.scheduleExamLocationModel.pageLoad = pageLoad;
          try {
            if (response && response.response && response.response.results) {
              this.scheduleExamLocationModel.examLocations = response.response.results;
              this.highlightAddress(response.response.results[0]);
              this.setScroll();
            }
          }
          catch (ex) {
            this.scheduleExamLocationModel.examLocations = [];
          }
        });
      },
      error => {
        this._utility.onErrorCallback(error, () => {
          this.scheduleExamLocationModel.pageLoad = pageLoad;
          this.scheduleExamLocationModel.examLocations = [];
        });
      },
      () => {
      })
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-location/schedule-exam-location.component.ts